import { DNotificationToastContainer, triggerToastNotification } from "@dfa/ui-platform";
import { createRoot } from "react-dom/client";

type triggerToastNotificationArgs = Parameters<typeof triggerToastNotification>;

export const triggerToast = <P = unknown,>(
	toast: React.ComponentType<P>,
	toastProps: P,
	settings?: triggerToastNotificationArgs[2]
) => {
	const bodyNode = document.querySelector("body");
	const toastContainerNode = document.querySelector(".d-notification-toast-container");

	/* 
		To have one universal spot for all toasts we must mount one <DNotificationToastContainer/> which will be where toasts are injected
	*/
	if (!toastContainerNode && bodyNode) {
		const rootNode = document.createElement("div");
		rootNode.className = "d-notification-toast-container";
		bodyNode.append(rootNode);

		const root = createRoot(rootNode);
		root.render(<DNotificationToastContainer />);
	}

	triggerToastNotification<typeof toastProps>(toast, toastProps, settings);
};
